/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class JobFailedNotificationArguments {
  /**
  * The id of the job
  */
  'id'?: string;
  /**
  * The start time of the job
  */
  'startTime'?: Date;
  /**
  * The end time of the job
  */
  'endTime'?: Date;
  /**
  * The error message
  */
  'error'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "startTime",
      "baseName": "startTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endTime",
      "baseName": "endTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return JobFailedNotificationArguments.attributeTypeMap;
  }

  public constructor() {
  }
}

